import { useMutation } from "@tanstack/react-query";

type GenerateTextInp = {
  token: string;
  controller?: AbortController;
};
const generateText = async ({ token, controller }: GenerateTextInp) => {
  const res = await fetch("/api/chat", {
    signal: controller?.signal,
    method: "POST",
    body: JSON.stringify({ token }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Failed to generate text, please try again!");
  }
  const data = await res.json();
  if (!data.success) {
    throw new Error(data.message);
  }
  return data;
};
export const useGenerateTextMutation = () => {
  return useMutation({
    mutationFn: generateText,
  });
};
